import Axios from "axios";
import { useEffect, useState } from "react";
import { API_URL } from "../../../../config";
import { AUTH_TYPES } from "../../../../context/reducers/authReducers";
import useStore from "../../../../context/useStore";

// Libellés des rôles du back-office, miroir de ROLES[PER_BO] dans
// perceval-api (models/Role.js). La clé vient de roles/mine (myRoleAtom).
export const LIBELLES_ROLES = {
  ADMIN: "Admin",
  MANAGER: "Gestionnaire",
  COLLABORATOR: "Collaborateur",
  SOCIAL: "Social",
  PARTNER: "Partenaire",
};

export const libelleDuRole = (cle) => (cle ? LIBELLES_ROLES[cle] || cle : "");

export const nomComplet = (user = {}) => [user.firstname, user.lastname].filter(Boolean).join(" ");

export const initiales = (user = {}) =>
  [user.firstname, user.lastname]
    .map((partie) => (partie ? String(partie).trim().charAt(0).toUpperCase() : ""))
    .join("");

// files/avatars/:id renvoie toujours une adresse : celle de la photo, ou
// celle de l'image par défaut (default.jpg) quand l'utilisateur n'en a pas.
export const estPhotoParDefaut = (url) => typeof url !== "string" || !url || /(^|\/)default\.jpg(\?|$)/.test(url);

// Photo de profil du compte connecté, rechargée quand Mon compte en enregistre
// une nouvelle (drapeau `newImage` posé par ImageFileCrop, remis à faux ici
// comme le faisaient l'ancienne Sidenav et l'ancienne barre haute).
export function usePhotoProfil(user = {}, actif = true) {
  const [state, dispatch] = useStore();
  const [photo, setPhoto] = useState(null);
  const [version, setVersion] = useState(0);
  const id = user.id;

  useEffect(() => {
    if (!user.newImage) return;
    setVersion((valeur) => valeur + 1);
    dispatch({ type: AUTH_TYPES.SET_CURRENT_USER, payload: { ...state.auth.user, newImage: false } });
  }, [user.newImage]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!actif || !id) {
      setPhoto(null);
      return undefined;
    }
    let enCours = true;
    Axios.get(API_URL + "files/avatars/" + id)
      .then((reponse) => {
        if (!enCours) return;
        const url = reponse && reponse.data;
        setPhoto(estPhotoParDefaut(url) ? null : `${url}?${Date.now()}`);
      })
      .catch(() => enCours && setPhoto(null));
    return () => {
      enCours = false;
    };
  }, [actif, id, version]);

  return photo;
}
